import React from "react";
import { useDispatch } from "react-redux";

import { logError } from "repoV2/utils/common/error/error";
import { debugLogs } from "repoV2/features/Common/modules/DebugLogs/utils/Logs.utils";
import { QUESTION_PLACEMENT } from "repoV2/features/Listing/Listing.constants";
import { callCheckoutCustomQuestionsApi } from "./apis/CustomQuestionsApi/CustomQuestionsApi";
import { CHECKOUT_PAGES_ACTION_TYPES } from "../constants/CheckoutPagesReducer";
import { IBookingQuestion } from "./apis/CustomQuestionsApi/ICustomQuestionsApi.interface";

const useFetchNSetCheckoutPageCustomQuestions = ({
    hostName,
    listingSlug,
    listingUuid,
}: {
    hostName: string;
    listingUuid: string;
    listingSlug: string;
}) => {
    const dispatch = useDispatch();

    const getCheckoutPageCustomQuestions = async () => {
        try {
            const { leads_questions, booking_questions = [] } =
                await callCheckoutCustomQuestionsApi({
                    hostName,
                    listingSlug,
                });
            /**
             * We need to filter the booking questions here, as it contain both the
             * pre and post booking questions
             */
            const filteredBookingQuestions = booking_questions?.filter(
                (item: IBookingQuestion) =>
                    item?.question_placement ===
                    QUESTION_PLACEMENT.BEFORE_BOOKING
            );
            dispatch({
                type: CHECKOUT_PAGES_ACTION_TYPES.SET_CUSTOM_QUESTIONS_DATA,
                payload: {
                    data: {
                        leads_questions,
                        booking_questions: filteredBookingQuestions,
                    },
                    isFetched: true,
                    listingUuid,
                },
            });
        } catch (error) {
            debugLogs({
                data: {
                    call: "calling the checkout basic details, section 5 for custom questions",
                    hostName,
                    listingSlug,
                    href: window.location.href,
                    listingUuid,
                },
                metaData: {},
            });
            logError({
                error,
                when: "calling custom questions api in checkout page mount",
                occuredAt:
                    "repoV2/features/CheckoutPages/utils/useFetchNSetCheckoutPageCustomQuestions.ts",
            });
        }
    };

    React.useEffect(() => {
        getCheckoutPageCustomQuestions();
    }, []);
};

export default useFetchNSetCheckoutPageCustomQuestions;
